import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowUpLeft } from 'lucide-react';
import { isSaudiBrand } from '../../../products/saudi/utils/isSaudiBrand';

export default function QuickAction({ label, href, icon: Icon, index = 0 }) {
  const qawaem = isSaudiBrand();
  const text = label || '—';

  const content = qawaem ? (
    <>
      <div className="qawaem-dash-quick-body">
        {Icon ? (
          <span className="qawaem-dash-quick-icon" aria-hidden>
            <Icon className="h-4 w-4" />
          </span>
        ) : null}
        <span className="qawaem-dash-quick-label">{text}</span>
      </div>
      <ArrowUpLeft
        className="qawaem-dash-quick-arrow rtl:rotate-90"
        aria-hidden
      />
    </>
  ) : (
    <>
      <div className="flex items-center gap-3 min-w-0">
        {Icon ? (
          <span className="glass-stat-icon shrink-0 p-2.5 rounded-xl">
            <Icon className="h-4 w-4" aria-hidden />
          </span>
        ) : null}
        <span className="text-sm font-medium truncate text-white/90">{text}</span>
      </div>
      <ArrowUpLeft className="h-4 w-4 shrink-0 rtl:rotate-90 text-white/40" aria-hidden />
    </>
  );

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2 + index * 0.04 }}
    >
      <Link
        to={href}
        className={
          qawaem
            ? 'qawaem-dash-quick-link group'
            : 'glass-panel flex items-center justify-between gap-3 p-4 hover:scale-[1.01] transition-transform duration-200 group'
        }
      >
        {content}
      </Link>
    </motion.div>
  );
}
